import React from "react";
import Header from "../layouts/Header/";
import Footer from "../layouts/Footer";
import SectionHeading from "../components/SectionHeading";


const CryptoPriceAI = () => {
  return (
    <>
      <Header />


      <section className="section-padding-100 service_single_content_area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1">
              <div className="service_single_content text-center mb-100">
                <SectionHeading
                  title="Crypto Price AI"
                  text="Intelligent Cryptocurrency Price Analysis & Prediction"
                />
                <div className="service_cta mt-50">
                    <h4 className="w-text" style={{ color: 'white' }}>Get intelligent answers to all your crypto price questions</h4>
                    <a href="https://crypto.databeast.ai/coin_price" className="btn dream-btn mt-30">
                      Try Crypto Price AI
                    </a>
                  </div>
                <div className="service_content_area text-left mt-50">
                  <p className="w-text">
                    Our Crypto Price AI is an advanced artificial intelligence model designed to answer any question 
                    related to cryptocurrency prices. Leveraging machine learning and historical data analysis, 
                    our AI provides insights and predictions to help traders and investors make informed decisions.
                  </p>
                  
                  <div className="service_features mt-30">
                    <h4 className="w-text" style={{ color: 'white' }}>What You Can Ask:</h4>
                    <ul className="w-text" style={{ color: 'white' }}>
                      <li><i className="fa fa-check"></i> Current price information for any cryptocurrency</li>
                      <li><i className="fa fa-check"></i> Historical price analysis and trends</li>
                      <li><i className="fa fa-check"></i> Price correlation between different cryptocurrencies</li>
                      <li><i className="fa fa-check"></i> Market cap analysis and comparisons</li>
                      <li><i className="fa fa-check"></i> Trading volume insights</li>
                      <li><i className="fa fa-check"></i> Price potential and growth analysis</li>
                    </ul>
                  </div>
                  
                  <div className="service_features mt-30">
                    <h4 className="w-text" style={{ color: 'white' }}>Key Benefits:</h4>
                    <ul className="w-text" style={{ color: 'white' }}>
                      <li><i className="fa fa-check"></i> Natural language processing for intuitive interactions</li>
                      <li><i className="fa fa-check"></i> Data-driven insights with technical analysis</li>
                      <li><i className="fa fa-check"></i> Real-time price updates and alerts</li>
                      <li><i className="fa fa-check"></i> Personalized cryptocurrency watchlists</li>
                      <li><i className="fa fa-check"></i> Market sentiment correlation with price movements</li>
                    </ul>
                  </div>

                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CryptoPriceAI;